<template>
    <div class="wrap-search center-section">
        <div class="wrap-search-form">
            <!-- Formulário de busca -->
            <form @submit.prevent="search" id="form-search-top" name="form-search-top">
                <!-- <input type="text" id="search" name="search" v-model="searchQuery" placeholder="Do que você precisa?"> -->
                <!-- <vue-bootstrap-typeahead
        v-model="searchQuery"
        :data="autoCompleteItems"
        @hit="search()"
    /> -->

                <vue-simple-suggest :prevent-submit="false"
                                    v-model="searchQuery"
                                    :list="autoCompleteItems"
                                    :filter-by-query="true"
                                    ref="suggestComponent"
                                    @select="submitAutoComplete"
                                    :styles="autoCompleteStyle"
                                    displayProperty="descricao"
                                    placeholder="Do que você precisa?"
                                    aria-label="Pesquisa">
                    <div slot="suggestion-item" slot-scope="scope">
                        <span v-html="boldenSuggestion(scope)"></span>
                    </div>
                </vue-simple-suggest>

                <button aria-label="Justify" form="form-search-top" type="submit">
                    <i class="fa fa-search" aria-hidden="true"></i>
                </button>
            </form>

            <!-- Auto Complete -->
            <!-- <div v-if="showAutoComplete" class="div-autocomplete">
                <ul class="autocomplete">
                    <li v-for="(item, index) in autoCompleteItems" :key="index" @click="submitAutoComplete(item)" v-html="item"></li>
                </ul>
            </div> -->
        </div>
    </div>
</template>
<style type="text/css">
    .vue-simple-suggest input {
        cursor: auto;
    }
</style>
<script>
import VueSimpleSuggest from 'vue-simple-suggest/lib'

export default {
    name: 'Search',
    components: {
        VueSimpleSuggest
    },
    data() {
        return {
            searchQuery: '',
            showAutoComplete: false,
            autoCompleteItems: [],
            autoCompleteStyle: {
                inputWrapper: "",
                defaultInput: "form-control py-2 border-right-0 border",
                suggestions: "position-absolute list-group z-1000",
                suggestItem: "list-group-item"
            }
        }
    },
    mounted() {
        let hours = 12;
        if(localStorage.buscaCacheExpires && localStorage.buscaCacheExpires != null){
            let time = new Date().getTime()
            let timelast = localStorage.buscaCacheExpires;

            // console.log('timelast', timelast)

            let result = time - timelast;

            hours = this.msToHMS(result);
            this.setInputAriaAttributes();
        }
        //// console.log('hours', hours)

        if(localStorage.buscaCache && hours < 6){
            this.autoCompleteItems = localStorage.buscaCache;
            this.autoCompleteItems = this.autoCompleteItems.split(',');
        }else{
            let xhr = new XMLHttpRequest();

            xhr.onload = () => {
                if (xhr.status == 200) {
                    this.autoCompleteItems = JSON.parse(xhr.responseText)
                    this.autoCompleteItems = this.autoCompleteItems.filter(this.onlyUnique)
                    localStorage.buscaCache = this.autoCompleteItems;
                    localStorage.buscaCacheExpires = new Date().getTime()
                }
            }

            xhr.open("GET", this.$apiUrl + "Produto.svc/getitensautocomplete")
            xhr.send()

        }

        //this.searchQuery = localStorage.searchQuery
    },
    methods: {
        onlyUnique: function(value, index, self) {
           return self.indexOf(value) === index;
        },
        boldenSuggestion(scope) {
            if (!scope) return scope;
            const { suggestion, query } = scope;
            let result = this.$refs.suggestComponent.displayProperty(suggestion);
            if (result.split(' ').filter((country) => country.startsWith(query.toUpperCase())).length >= 1) {
                const texts = query.split(/[\s-_/\\|\.]/gm).filter(t => !!t) || [''];
                return result.replace(new RegExp('(.*?)(' + texts.join('|') + ')(.*?)', 'gi'), '$1<b>$2</b>$3');
            }
            else {
                return result;
            }
        },
        setInputAriaAttributes() {
            $(".vue-simple-suggest input").attr('aria-activedescendant', '')
            $(".vue-simple-suggest input").attr('aria-autocomplete', 'list')
        },
        msToHMS: function (ms) {
            // 1- Convert to seconds:
            var seconds = ms / 1000;
            // 2- Extract hours:
            var hours = parseInt( seconds / 3600 ); // 3,600 seconds in 1 hour
            seconds = seconds % 3600; // seconds remaining after extracting hours
            // 3- Extract minutes:
            var minutes = parseInt( seconds / 60 ); // 60 seconds in 1 minute
            // 4- Keep only seconds not extracted to minutes:
            seconds = seconds % 60;
            // console.log('hours', hours, 'minutes', minutes, 'seconds', seconds)
            return hours*60;
        },
        search: function () {
            let searchQuery = this.searchQuery.trim()

            if (searchQuery.length < 6 || (searchQuery.length <= 8 && (searchQuery.includes(',') || searchQuery.includes('.')))) {
                searchQuery = searchQuery.replace(',', '.')

                const isShortInteger = /^\d{1,4}$/.test(searchQuery)

                const isDecimal = /^\d+(\.\d+)?$/.test(searchQuery)

                if (isShortInteger || isDecimal) {
                    const minValue = parseFloat(searchQuery)

                    let maxValue = minValue + (minValue * 0.1)
                    if (maxValue - minValue < 3) {
                        maxValue = minValue + 3
                    }
                    location.href = `/loja/categoria/energia-solar?filtro=3:${minValue}~${maxValue}`
                }
            }

            localStorage.searchQuery = searchQuery

            const searchQueryUri = encodeURIComponent(searchQuery.toLowerCase())
            this.$router.push(`/loja/pesquisa/${searchQueryUri}`)
        },
        submitAutoComplete: function (item) {
            // Aplica o item a barra de busca
            this.searchQuery = this.removeHTML(item);

            this.search();

            this.showAutoComplete = false;
        },
        removeHTML: function (string) {
            // Limpa o HTML da string
            return string.replace(/<[^>]*>?/gm, '');
        }
    },
}
</script>
